<template>
    <div>
        
        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <div class="col-md-2">
                    <a 
                        class="navbar-brand ml-3"
                        style="font: normal normal normal 16px/25px Poppins;">Cari SJ</a>
                </div>
                <div class="col-md-8" style="">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Nomor SJ"
                        aria-label="Search"
                        style="display: flex; font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                    >
                </div>
                <div 
                    class="col-md-2 text-right" 
                    style="display: flex; justify-content: flex-end">
                    <button
                        class="btn"
                        type="button"
                        style="
                            background-color: #1B698E; 
                            color: white; 
                            padding: 0 50px; 
                            height: 100%; 
                            font-weight: bold; 
                            display: flex; 
                            align-items: center; 
                            font: normal normal 600 14px/21px Poppins;"
                        @click="vue_universal_table.update++"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox">

<div class="mb-4 row">
                <div class="col-md-3">
                    <!-- <button class="btn btn--mpm--transporter" @click="requestFullScreen">Full Screen</button> -->
                </div>
                <div class="col-md-4 text-center" style="display: flex; flex-direction: column-reverse;">
                    <h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins;">Riwayat Transfer TO</h3>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-4">
                    <div class="d-flex">
                        <div class="col-3"
                            style="display: flex; align-items: center; font: normal normal normal 12px/18px Poppins;">
                            <span style="font: normal normal normal 12px/18px Poppins;">Filter Tanggal</span>
                        </div>
                        <div class="col-9" style="font: normal normal normal 12px/18px Poppins;">
                            <div class="d-flex justify-content-between">
                                <flat-pickr :config="rangePickr" placeholder="Select Date" v-model="selected.date"
                                    style="font: normal normal normal 12px/18px Poppins;"></flat-pickr>
                                <button class="btn ml-3" :class="{'d-none': hideButton}" type="button" style="
                  background-color: #f36f21;
                  color: white;
                  width: 100%;
                  font-weight: bold;
                  margin: 0;
                " @click="aturUlangMultipleItem">
                                    Atur Ulang
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <vue-universal-table
                ref="universalTable"
                api_url="/api/monitoring/history-transfer-to"
                :filter="filter"
                :update="vue_universal_table.update"
                :fields="vue_universal_table.fields"
                :buttons="vue_universal_table.buttons"
                :infinite_scroll="true"
                :multiple_select="true"
                :select_row_variable="'id'"
                @onSelectionChange="handleSelectionChange"

                sort_order="DESC"
                @onAturUlang="aturUlangSingleItem"
                @fetchEnd="handleFetchEnd"
                sort_by="to_tgl_sl"
                style="font: normal normal normal 12px/18px Poppins;"
            ></vue-universal-table>

            <UpdateTransferTO
                :data="modal.data"
                v-if="modal.edit"
                @closeModal="modal.edit = false"
                @refreshTable="vue_universal_table.update++"
            />
        </div>
        <!-- Table End -->
    </div>
</template>

<script>
    import moment from 'moment';
    import debounce from 'debounce';

    export default {
        metaInfo : {
            title : 'Monitoring Transfer TO'
        },
        data () {
            let startDate = moment().startOf('year').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                rangePickr: {
                    mode: 'range',
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d-m-Y",
                    altInputClass: 'form-control input mpm--transporter--flatpickr'
                },
                modal: {
                    data: null,
                    edit: false
                },
                hideButton: true,
                selected : {
                    dateButtonsIndex : 2,
                    date : `${startDate} to ${currentDate}`
                },
                filter : {
                    search : '',
                    start: startDate,
                    end:currentDate
                },
                vue_universal_table : {
                    fields : [
                        {title:"NO SJ", variable:"no_sl"},
                        {title:"NO TO", variable:"no_referensi", disable_sort: true},
                        {title:"TANGGAL SJ/TO", variable:"to_tgl_sl"},
                        {title:"NOPOL", variable:"nopol"}
                    ],
                    buttons: [
                        { title: 'Atur Ulang', variable: null, class: 'btn btn-outline-secondary', condition: "data.status_pengiriman != 4" }
                    ],
                    update : 0
                },
                selectedRowIds: [],
                selectedFullData: []
            }
        },
        components : {
        },
        mounted () {

        },
        watch : {
            'selected.date' () {
                let split = this.selected.date.split(" to ");
                this.filter.start = split[0];
                this.filter.end = split.length > 1 ? split[1] : split[0];
                
                this.updateDebounceData();
            },
            'selectedRowIds'() {
                if (this.selectedRowIds.length > 0) {
                    this.hideButton = false;
                } else {
                    this.hideButton = true;
                }
            }
        },
        methods : {
            updateDebounceData: debounce(function () {
                this.vue_universal_table.update++
            }, 1500),
            showModal(data) {
                this.modal.data = data;
                this.modal.edit = true;
            },
            handleSelectionChange(selectedRowIds) {
                this.selectedRowIds = selectedRowIds;
                this.selectedFullData = this.vue_universal_table.data.filter(row =>
                    selectedRowIds.includes(row.id)
                );
            },
            handleFetchEnd() {
                if (this.$refs.universalTable && this.$refs.universalTable.tableData) {
                    this.vue_universal_table.data = this.$refs.universalTable.tableData;
                }
            },
            aturUlangSingleItem(data) {
                let parseData = JSON.parse(data);
                this.$swal.fire({
                    icon: 'warning',
                title: 'Apakah Anda Yakin?',
                html: `
                    <div class="custom-swal-content">
                        <p>Anda akan atur ulang</p>
                        <span class="data-row">No SJ : <strong>${parseData.no_sl}</strong></span>
                        <span class="data-row">No TO : <strong>${parseData.no_referensi}</strong></span>
                        <span class="data-row">NOPOL : <strong>${parseData.nopol}</strong></span>
                        <span class="data-row">Tanggal SJ : <strong>${parseData.to_tgl_sl}</strong></span>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: 'Atur Ulang',
                cancelButtonText: 'Batal',
                confirmButtonColor: '#2c5282',
                cancelButtonColor: '#ffffff',
                customClass: {
                    popup: 'custom-swal-popup',
                    confirmButton: 'swal2-confirm',
                    cancelButton: 'swal2-cancel'
                },
                buttonsStyling: false,
                reverseButtons: true
                }).then((result) => {
                    let form = {
                        id: parseData.id.toString(),
                        nopol: parseData.nopol,
                        no_referensi: parseData.no_referensi
                    }
                    if (result.value) {
                        this.$http.put('/api/monitoring/update-history-transfer-to',form)
                        .then(() => {
                            this.$swal.fire({
                                title: 'Sukses!',
                                text: "Berhasil atur ulang TO",
                                icon: 'success',
                            })

                            this.vue_universal_table.update++;
                        }).catch((err) => {
                            this.$swal.fire({
                                title: "Error!",
                                icon: "error",
                                type: "error",
                                text: err.response.data.message
                            })
                        })
                    }
                })
            },
            aturUlangMultipleItem() {
            let htmlContent = '';
            let nopol = '';

            htmlContent = `<div class="custom-swal-content"><p>Anda akan melakukan atur ulang</p>`;

            let allNoReferensi = this.selectedFullData.map(val => val.no_referensi);
            let allNoSj = this.selectedFullData.map(val => val.no_sl);
            let allTglSl = this.selectedFullData.map(val => val.from_tgl_sl)

            allNoSj.forEach((sj, index) => {
                    if (index === 0) {
                        htmlContent += `<span class="data-row">No SJ : <strong>${index + 1}. ${sj}</strong></span>`;
                    } else {
                        htmlContent += `<span class="data-row" style="padding-left: 52px;"><strong>${index + 1}. ${sj}</strong></span>`;
                    }
                });

            allNoReferensi.forEach((to, index) => {
                    if (index === 0) {
                        htmlContent += `<span class="data-row">No TO : <strong>${index + 1}. ${to}</strong></span>`;
                    } else {
                        htmlContent += `<span class="data-row" style="padding-left: 55px;"><strong>${index + 1}. ${to}</strong></span>`;
                    }
                });

            
            
            this.selectedFullData.forEach((item) => {
                nopol = item.nopol;
            });

            htmlContent += `<span class="data-row">NOPOL : <strong>${nopol}</strong></span>`;
            allTglSl.forEach((tglSl, index) => {
                    if (index === 0) {
                        htmlContent += `<span class="data-row">No TO : <strong>${index + 1}. ${tglSl}</strong></span>`;
                    } else {
                        htmlContent += `<span class="data-row" style="padding-left: 55px;"><strong>${index + 1}. ${tglSl}</strong></span>`;
                    }
                });

            htmlContent += '</div>';
            

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Apakah Anda Yakin?',
                    html: htmlContent,
                    showCancelButton: true,
                    confirmButtonText: 'Atur Ulang',
                    cancelButtonText: 'Batal',
                    customClass: {
                        popup: 'custom-swal-popup',
                        confirmButton: 'swal2-confirm',
                        cancelButton: 'swal2-cancel'
                    },
                    buttonsStyling: false,
                    reverseButtons: true,
                    focusConfirm: false
                }).then((result) => {
                    let form = {
                            id: this.selectedFullData.map(val => val.id).join(','),
                            nopol: [...new Set(this.selectedFullData.map(val => val.nopol))].join(','),
                            no_referensi: this.selectedFullData.map(val => val.no_referensi).join(',')
                        }
                    if (result.value) {
                        this.$http.put('/api/monitoring/update-history-transfer-to',form)
                        .then(() => {
                            this.$swal.fire({
                                title: 'Sukses!',
                                text: "Berhasil atur ulang TO",
                                icon: 'success',
                            })

                            this.vue_universal_table.update++;
                            this.hideButton = true;
                        }).catch((err) => {
                            this.$swal.fire({
                                title: "Error!",
                                icon: "error",
                                type: "error",
                                text: err.response.data.message
                            })
                        })
                    }
                })
            }
        }
    }
</script>

<style>
.custom-swal-popup {
            border-radius: 12px;
            padding: 30px;
        }
        
        .custom-swal-content {
            font-size: 16px;
            color: #666;
            line-height: 1.6;
            text-align: center;
        }
        
        .custom-swal-content p {
            margin-bottom: 20px;
            color: #333;
        }
        
        .custom-swal-content .data-row {
            color: #333;
            display: block;
            margin: 8px 0;
        }
        
        .custom-swal-content .data-row strong {
            font-weight: 600;
        }
        
        .swal2-actions {
            margin-top: 30px !important;
            gap: 10px;
        }
        
        .swal2-confirm {
            background-color: #2c5282 !important;
            color: white !important;
            padding: 10px 30px !important;
            border-radius: 6px !important;
            font-size: 16px !important;
            font-weight: 500 !important;
            border: none !important;
            box-shadow: none !important;
            min-width: 120px;
        }
        
        .swal2-confirm:hover {
            background-color: #2d3748 !important;
        }
        
        .swal2-cancel {
            background-color: transparent !important;
            color: #2c5282 !important;
            border: 1px solid #e2e8f0 !important;
            padding: 10px 30px !important;
            border-radius: 6px !important;
            font-size: 16px !important;
            font-weight: 500 !important;
            min-width: 120px;
        }
        
        .swal2-cancel:hover {
            background-color: #f7fafc !important;
            border-color: #cbd5e0 !important;
        }
</style>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>